/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Moment_PillInputs */

const en_us2_today_moment_pill = /** @type {(inputs: Today_Moment_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrospective`)
};

const pt_br2_today_moment_pill = /** @type {(inputs: Today_Moment_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrospectiva`)
};

const es_419_today_moment_pill = /** @type {(inputs: Today_Moment_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrospectiva`)
};

const pt_pt2_today_moment_pill = /** @type {(inputs: Today_Moment_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrospetiva`)
};

const fr_fr2_today_moment_pill = /** @type {(inputs: Today_Moment_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rétrospective`)
};

const de_de2_today_moment_pill = /** @type {(inputs: Today_Moment_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückblick`)
};

const it_it2_today_moment_pill = /** @type {(inputs: Today_Moment_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo`)
};

/**
* | output |
* | --- |
* | "Retrospective" |
*
* @param {Today_Moment_PillInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_moment_pill = /** @type {((inputs?: Today_Moment_PillInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Moment_PillInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_moment_pill(inputs)
	if (locale === "es-419") return es_419_today_moment_pill(inputs)
	if (locale === "pt-PT") return pt_pt2_today_moment_pill(inputs)
	if (locale === "fr-FR") return fr_fr2_today_moment_pill(inputs)
	if (locale === "de-DE") return de_de2_today_moment_pill(inputs)
	if (locale === "it-IT") return it_it2_today_moment_pill(inputs)
	return en_us2_today_moment_pill(inputs)
});
export { today_moment_pill as "today.moment_pill" }